/** ページ下端の余白。下タブと Undo スナックバーに隠れないようにする。 */
export const PAGE_BOTTOM = 'pb-[calc(9rem+env(safe-area-inset-bottom))]';
